module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("You, Naughty Mum!")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#a-tale-by-calvino-at-calvino-prize-for-unpublished-tales"
    }
  }, [_vm._v("A Tale by Calvino at Calvino Prize for Unpublished Tales")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#you-naughty-mum"
    }
  }, [_vm._v("You, Naughty Mum!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-butterflies-country"
    }
  }, [_vm._v("The Butterflies’ Country")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#you-naughty-father-cacciari",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You, Naughty Father Cacciari!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#sweets-from-strangers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweets from Strangers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#nostalgia-and-fear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nostalgia and Fear")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-solution",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#b-solution",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#c-solution",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#inside-oronzos-big-head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inside Oronzo’s Big Head")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#pavor-nocturnus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pavor Nocturnus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#big-fat-and-dumb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big, Fat, and Dumb")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-unfindable-toy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unfindable Toy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#tranquilla-and-vivacious",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tranquilla and Vivacious")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#whitedwarf-and-the-seven-snows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whitedwarf and the Seven Snows")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-mechanical-child",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mechanical Child")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#down-there-in-arizona",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down There in Arizona")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-ogre-of-the-seven-caves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ogre of the Seven Caves")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-father-who-believed-in-father-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Father Who Believed in Father Christmas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-promontory-game",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Promontory Game")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#old-lucìn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Lucìn")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-most-frightening-but-most-scientific-story-of-the-fight-between-good-and-evil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Most Frightening but Most Scientific Story of the Fight Between Good and Evil")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#summarizing",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#interdisciplinary-reflection",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#father-christmass-son",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father Christmas’s Son")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#richard-and-the-dog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard and the Dog")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#our-lady-of-milk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Lady of Milk")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#the-telly-addiction-explained-to-my-grandpa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Telly Addiction Explained to My Grandpa")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#potatoland-a-dream-or-a-bad-fairy-tale",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potatoland: A Dream (Or a Bad Fairy Tale?)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#the-domestic-pig-and-other-poems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Domestic Pig and Other Poems")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0